
(function () {
    'use strict';

    angular.module('table')
        .directive('fixedHeader', fixedHeader)
        .directive('repeatListener', repeatListener);

    fixedHeader.$inject = ['$timeout', '$window'];

    function fixedHeader($timeout, $window) {
        return {
            restrict: 'A',
            link: link
        };

        function link($scope, $elem, $attrs) {
            var elem = $elem[0];
            var navBar = document.getElementsByClassName('navbar-absolute-top')[0];
            var scrollDiv = elem.parentElement;
            var mainHeader = elem.querySelector('#mainHead');
            var duplicateHeader = elem.querySelector('#duplicateHead');
            var mainHeaderColumns = mainHeader.children[0].children;
            var duplicateHeaderColumns = duplicateHeader.children[0].children;

            function scrollHandler() {
                //check if bottom reached. If true, call the function specified in onScrollBottom attr
                if (scrollDiv.scrollTop + scrollDiv.offsetHeight > scrollDiv.scrollHeight - 50) {
                    $scope.$apply($attrs.onScrollBottom);
                }
                //adjust duplicate header position
                duplicateHeader.style.left = (-scrollDiv.scrollLeft + 1) + 'px';
            }

            angular.element(scrollDiv).bind('scroll', scrollHandler);

            function fixHeader() {
                for (var i = 0; i < duplicateHeaderColumns.length; i++) {
                    duplicateHeaderColumns[i].style.width = mainHeaderColumns[i].offsetWidth + 'px';
                }

                duplicateHeader.style.width = mainHeader.offsetWidth + 'px';
                mainHeader.style.top = navBar.offsetHeight + 'px';
                duplicateHeader.style.top = navBar.offsetHeight + 'px';
                duplicateHeader.style.display = 'block';
                elem.style.marginTop = (navBar.clientHeight - 49) + 'px';
            }

            angular.element($window).bind('resize', function () {
                fixHeader();
            });

            $scope.$on('redrawTable', function () {
                setTimeout(fixHeader, 100);
            });

            $scope.$on('newSearchString', function () {
                setTimeout(fixHeader, 100);
            });
        }
    }

    function repeatListener() {
        return function (scope) {
            if (scope.$last) {
                scope.$emit('redrawTable');
            }
        }
    }
})();
